import { ADD_ACCESS_CONTROL_DATA, UPDATE_ACCESS_CONTROL } from './actionCreator';

const initialState = {
  accessControl: [],
  loading: false,
};

export const accessControlReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ACCESS_CONTROL_DATA:
      return { ...state, accessControl: action.payload };
    case UPDATE_ACCESS_CONTROL:
      return {
        ...state,
        accessControl: {
          ...state.accessControl,
          [action.payload.sectionKey]: action.payload.updatedItems,
        },
      };
    default:
      return state;
  }
};
